import React from 'react'
import './Claim_Support_Component.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

const Claim_Support_Component = ({val,IMG_URL}) => {


    return (
        <section className='Claim_Support_Component'>

            <div className='top_section'>
                <div className='img_holder'>
                    <img src='/assets/Image/Plan_Details/claim_support/guaranteed.png' className='top_img' />
                </div>

                <div className='text_holder'>
                    <p className='heading'>PROFCYMA Guarantee</p>
                    <p className='sub_heading'>claim support for your family in those difficult times benefits</p>
                </div>
            </div>

            <div className='swiper_div'>
                <Swiper
                    spaceBetween={15}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true
                    }}
                    modules={[Pagination]}
                    autoplay={{ delay: 300 }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.2,
                            spaceBetween: 10,
                        },
                        350: {
                            slidesPerView: 1.4,
                            spaceBetween: 10,
                        },
                        420: {
                            slidesPerView: 1.4,
                            spaceBetween: 10,
                        },
                        486: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 10,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        1200: {
                            slidesPerView: 5.5,
                            spaceBetween: 10,
                        },
                        1400: {
                            slidesPerView: 5.5,
                            spaceBetween: 15,

                        },


                    }}
                >
                    {val?.f_i_profcyma_guarantees?.map((val1)=>
                    <SwiperSlide > 
                        <div className='support_card_holder one'>
                            <div className='img_holder'>
                                <img src={`${IMG_URL}${val1?.profcyma_guarantee?.image}`} className='img' />
                            </div>
                            <p className='simple_text'>{val1?.profcyma_guarantee?.name}</p>
                            <p className='bold_text'>{val1?.profcyma_guarantee?.sub_name}</p>
                        </div>
                    </SwiperSlide>)}

                    {/* <SwiperSlide >
                        <div className='support_card_holder two'>
                            <div className='img_holder'>
                                <img src={"/assets/Image/Plan_Details/claim_support/img2.png"} className='img' />
                            </div>
                            <p className='bold_text'>Free </p>
                            <p className='simple_text'>counselling</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide >
                        <div className='support_card_holder three'>
                            <div className='img_holder'>
                                <img src={"/assets/Image/Plan_Details/claim_support/img3.png"} className='img' />
                            </div>
                            <p className='simple_text'>On ground support in</p>
                            <p className='bold_text'>110+ Cities</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide >
                        <div className='support_card_holder four'>
                            <div className='img_holder'>
                                <img src={"/assets/Image/Plan_Details/claim_support/img4.png"} className='img' />
                            </div>
                            <p className='simple_text'>Free documents</p>
                            <p className='bold_text'>pick-up</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide >
                        <div className='support_card_holder five'>
                            <div className='img_holder'>
                                <img src={"/assets/Image/Plan_Details/claim_support/img5.png"} className='img' />
                            </div>
                            <p className='bold_text'>₹ 440 Crore</p>
                            <p className='simple_text'>worth claim settled</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide >
                        <div className='support_card_holder six'>
                            <div className='img_holder'>
                                <img src={"/assets/Image/Plan_Details/claim_support/img6.png"} className='img' />
                            </div>
                            <p className='simple_text'>Special support team of</p>
                            <p className='bold_text'> 500+ Agents</p>
                        </div>
                    </SwiperSlide> */}

                </Swiper>

            </div>

            <div className='contact_us_div'>
                <p className='red_text'>For more information you can contact us at:</p>

                <p className='email_text'> <FontAwesomeIcon icon={faEnvelope} className='mail_icon me-3' /> care@profcymafinance.com</p>

                <p className='mobile_text'> <FontAwesomeIcon icon={faPhone} className='mail_icon me-3' />+91 111 222 333</p>

            </div>


        </section>
    )
}

export default Claim_Support_Component
